// fetch from api using createApi
import { CarModelCriteriaModel, CarModelGroup, CarModelModel } from "@/types/api"
import { baseApi } from "./baseApi"
import { createUrlQuery } from "@/utils/apiHelper"

export const carModelsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCarModels: builder.query<CarModelModel[], CarModelCriteriaModel>({
      query: (criteria) => `CarModels/?${createUrlQuery(criteria)}`,
      keepUnusedDataFor: 60 * 60 * 1000, // 1 hour
    }),
  }),
})

export const { useLazyGetCarModelsQuery } = carModelsApi